import { render, staticRenderFns } from "./SettingGoldMarketPlace.vue?vue&type=template&id=58999598&scoped=true&"
import script from "./SettingGoldMarketPlace.vue?vue&type=script&lang=js&"
export * from "./SettingGoldMarketPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58999598",
  null
  
)

export default component.exports